module.exports = __webpack_public_path__ + "static/media/MHRP39N0002.ff0b6c6a.svg";